import React, { useState } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import { ReactComponent as PriceIcon } from "feather-icons/dist/icons/rupiah-white.svg";
import { ReactComponent as ChevronLeftIcon } from "feather-icons/dist/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "feather-icons/dist/icons/chevron-right.svg";
import Paket_1 from "images/paket/Paket_1.jpeg"
import Paket_2 from "images/paket/Paket_2.jpeg"
import Paket_3 from "images/paket/Paket_3.jpeg"
import Paket_4 from "images/paket/Paket_4.jpeg"
import Paket_5 from "images/paket/Paket_5.jpeg"
import Paket_6 from "images/paket/Paket_6.jpeg"




const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20`;

const HeadingWithControl = tw.div`flex flex-col items-center sm:items-stretch sm:flex-row justify-between`;
const Heading = tw(SectionHeading)``;
const Controls = tw.div`flex items-center`;
const ControlButton = styled(PrimaryButtonBase)`
  ${tw`mt-4 sm:mt-0 first:ml-0 ml-6 rounded-full p-2`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const PrevButton = tw(ControlButton)``;
const NextButton = tw(ControlButton)``;

const CardSlider = styled(Slider)`
  ${tw`mt-16`}
  .slick-track { 
    ${tw`flex`}
  }
  .slick-slide {
    ${tw`h-auto flex justify-center mb-1`}
  }
`;

const Card = tw.div`h-full flex! flex-col sm:border max-w-sm sm:rounded-tl-4xl sm:rounded-br-5xl relative focus:outline-none`;

// ✅ Show image with real resolution (no cropping)
const CardImage = styled.img`
  ${tw`w-full rounded sm:rounded-none sm:rounded-tl-4xl`}
  height: auto;
  display: block;
`;

const TextInfo = tw.div`py-6 sm:px-10 sm:py-6`;
const TitleReviewContainer = tw.div`flex flex-col sm:flex-row sm:justify-between sm:items-center`;
const Title = tw.h5`text-2xl font-bold`;

const IconWithText = tw.div`flex items-center mr-6 my-2 sm:my-0`;
const IconContainer = styled.div`
  ${tw`inline-block rounded-full p-2 bg-gray-700 text-gray-100`}
  svg {
    ${tw`w-3 h-3`}
  }
`;
const Text = tw.div`ml-2 text-sm font-semibold text-gray-800`;

const PrimaryButton = tw(PrimaryButtonBase)`mt-auto sm:text-lg rounded-none w-full rounded sm:rounded-none sm:rounded-br-4xl py-3 sm:py-6`;

export default () => {
  const [sliderRef, setSliderRef] = useState(null);

  const sliderSettings = {
    arrows: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  };

  const cards = [
    {
      imageSrc: Paket_1,
      whatsappMessage: "Assalamu’alaikum,Saya tertarik dengan Paket Perjalanan Macau China-Special Shoping Tour. Mohon dibantu informasinya, apakah masih bisa booking untuk keberangkatan tersebut?"
    },
    {
      imageSrc: Paket_2,
      whatsappMessage: "Assalamu’alaikum,Saya tertarik dengan Paket Perjalanan The Story of Uzbekiztan. Mohon dibantu informasinya, apakah masih bisa booking untuk keberangkatan tersebut?"
    },
    {
      imageSrc: Paket_3,
      whatsappMessage: "Assalamu’alaikum,Saya tertarik dengan Paket Perjalanan Special Nature and Culture Tour China Exotic. Mohon dibantu informasinya, apakah masih bisa booking untuk keberangkatan tersebut?"
    },
    {
      imageSrc: Paket_4,
      whatsappMessage: "Assalamu’alaikum,Saya tertarik dengan Paket Umrah ini. Mohon dibantu informasinya, apakah masih bisa booking untuk keberangkatan tersebut?"
    },
    {
      imageSrc: Paket_5,
      whatsappMessage: "Assalamu’alaikum,Saya tertarik dengan Paket Umrah ini. Mohon dibantu informasinya, apakah masih bisa booking untuk keberangkatan tersebut?"
    },
    {
      imageSrc: Paket_6,
      whatsappMessage: "Assalamu’alaikum,Saya tertarik dengan Paket Umrah ini. Mohon dibantu informasinya, apakah masih bisa booking untuk keberangkatan tersebut?"
    },
  ];
  

  return (
    <Container>
      <Content>
        <HeadingWithControl>
          <Heading>Katalog Perjalanan Kami</Heading>
          <Controls>
            <PrevButton onClick={sliderRef?.slickPrev}><ChevronLeftIcon/></PrevButton>
            <NextButton onClick={sliderRef?.slickNext}><ChevronRightIcon/></NextButton>
          </Controls>
        </HeadingWithControl>

        <CardSlider ref={setSliderRef} {...sliderSettings}>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage src={card.imageSrc} alt={card.title} />
              <TextInfo>
                {/* <TitleReviewContainer>
                  <Title>{card.title}<br/>{card.locationText}</Title>
                </TitleReviewContainer> */}
                {/* <IconWithText>
                  <IconContainer>
                    <PriceIcon />
                  </IconContainer>
                  <Text>{card.pricingText}</Text>
                </IconWithText> */}
              </TextInfo>
              <PrimaryButton
  onClick={() => {
    const url = `https://wa.me/62818794354?text=${encodeURIComponent(card.whatsappMessage)}`;
    window.open(url, "_blank");
  }}
>
  Book Now
</PrimaryButton>

            </Card>
          ))}
        </CardSlider>
      </Content>
    </Container>
  );
};
